export const Permission = [
    {
        name: "จัดการผู้ใช้งาน",
        code: "Employees.Read",
        permit: false,
        actions: [
            {
                name: "เพิ่มผู้ใช้งาน",
                code: "Employees.Add",
                permit: false,
                actions: []
            },
            {
                name: "แก้ไขผู้ใช้งาน",
                code: "Employees.Edit",
                permit: false,
                actions: []
            },
        ]
    },
    {
        name: "จัดการบทบาท",
        code: "Role.Read",
        permit: false,
        actions: [
            {
                name: "เพิ่มบทบาท",
                code: "Role.Add",
                permit: false,
                actions: []
            },
            {
                name: "แก้ไขบทบาท",
                code: "Role.Edit",
                permit: false,
                actions: []
            },
        ]
    },
    {
        name: "จัดการหน่วยงาน",
        code: "Department.Read",
        permit: false,
        actions: [
            {
                name: "เพิ่มหน่วยงาน",
                code: "Department.Add",
                permit: false,
                actions: []
            },
            {
                name: "แก้ไขหน่วยงาน",
                code: "Department.Edit",
                permit: false,
                actions: []
            },
        ]
    },
    {
        name: "จัดการตำแหน่ง",
        code: "Position.Read",
        permit: false,
        actions: [
            {
                name: "เพิ่มตำแหน่ง",
                code: "Position.Add",
                permit: false,
                actions: []
            },
            {
                name: "แก้ไขตำแหน่ง",
                code: "Position.Edit",
                permit: false,
                actions: []
            },
        ]
    },
]  